"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __importDefault(require("../state/state"));
var $calcnumber = document.querySelector('.calc__number');
var sumCalorie = function () {
    var sumCal = 0;
    state_1.default.selectedItem.forEach(function (item) {
        sumCal += (item.calories * item.quantity);
    });
    sumCal *= state_1.default.sizeState.size;
    $calcnumber.textContent = "".concat(sumCal);
};
exports.default = sumCalorie;
